import { Search, X } from 'lucide-react';
import { format } from 'date-fns';
import { Input, Button } from '@predoc/cow';
import { PatientSearchProperties } from '../../types';
import { DatePickerInput } from '@/components/DatePickerInput';
import { PatientFilter } from './PatientFilter';

export const SearchFilterHeader = ({
  search,
  handleSearchChange,
}: {
  search: PatientSearchProperties;
  handleSearchChange: (search: PatientSearchProperties) => void;
}) => {
  return (
    <div className="flex items-center justify-between gap-4 px-6 py-4">
      <div className="flex gap-4">
        <div className="relative">
          <Search className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-gray-400" />
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleSearchChange({
                ...search,
                terms: e.target.value ? [e.target.value] : [],
              })
            }
            value={search.terms[0] || ''}
            placeholder="Search patients..."
            className="pr-10 pl-10"
          />
          {search.terms[0] && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleSearchChange({ ...search, terms: [] })}
              className="absolute top-1/2 right-2 h-6 w-6 -translate-y-1/2 p-0"
            >
              <X className="size-3" />
            </Button>
          )}
        </div>
        <div className="relative">
          <DatePickerInput
            onChange={(date) => {
              handleSearchChange({
                ...search,
                dateOfBirth: date ? format(date, 'yyyy-MM-dd') : undefined,
              });
            }}
            placeholder="Search DOB..."
            disableDates="future"
            clearable
          />
        </div>
      </div>
      <PatientFilter
        onFiltersChange={(filters) => {
          handleSearchChange({
            ...search,
            statuses: filters.statuses,
            modifiedFrom: filters.modifiedFrom,
            modifiedTo: filters.modifiedFrom ? filters.modifiedTo : undefined,
          });
        }}
      />
    </div>
  );
};
